"use strict";

jQuery(document).ready(function ($) {
  (function ($) {
    $.fn.scrollTo = function () {
      var that = this;
      return this.click(function (e) {
        var target = $(this).data('scroll-to'),
            timing = $(this).data('timing') || 800,
            bezier = [0.645, 0.045, 0.355, 1.000];
        e.preventDefault();

        if ($(target).length) {
          $(target).velocity("scroll", {
            duration: timing,
            easing: [0.645, 0.045, 0.355, 1.000]
          });
        }

        ;
      });
    };
  })(jQuery);

  $(function () {
    if ($('.js-scroll-to').length) {
      $('.js-scroll-to').scrollTo();
    }
  });
});